import axios from 'axios'

const {
  REACT_APP_MORTGAGE_URL
} = process.env;

export const bookAppointment = async (data: any) => {
  await axios.post(
    `${REACT_APP_MORTGAGE_URL}/api/teams/requestCallOrFaceToFaceAppointment`,
    data
  )
}

export const sendTeamsAppointment = async (data: any) => {
  await axios.post(`${REACT_APP_MORTGAGE_URL}/api/teams/scheduleAppointment`, data)
}
